"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useVideoInfo = void 0;

var _react = require("react");

var _VideoController = require("./controllers/VideoController");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var initialVideoInfo = {
  loopCount: 0,
  paused: false,
  duration: 30,
  currentTime: 0,
  gameTime: 0,
  progress: 0,
  active: false,
  video_id: "video",
  sourceCount: 0,
  multicamOpen: false,
  camera: "tracecam"
};

var useVideoInfo = function useVideoInfo(ref) {
  var controller = null;

  if (ref) {
    controller = _VideoController.VideoController.getInstance(ref.current);
  }

  var _useState = (0, _react.useState)(initialVideoInfo),
      _useState2 = _slicedToArray(_useState, 2),
      videoInfo = _useState2[0],
      setVideoInfo = _useState2[1];

  var onVideoInfoUpdate = function onVideoInfoUpdate(event) {
    var videoIdCheck = true;

    if (controller && event && event.detail) {
      videoIdCheck = controller.videoId === event.detail.video_id;
    }

    if (event && event.detail && videoIdCheck) {
      // get video info from event
      var vi = event.detail;
      var significantChange = false; // check if change require updatuseVideoInfo

      if (videoInfo.loopCount !== vi.loopCount) {
        significantChange = true;
      }

      if (videoInfo.paused !== vi.paused) {
        significantChange = true;
      }

      if (videoInfo.duration !== vi.duration) {
        significantChange = true;
      }

      var timeDiff = Math.abs(vi.currentTime - videoInfo.currentTime);

      if (timeDiff > 0.1) {
        // more than a tenth of second is significant
        significantChange = true;
      }

      if (videoInfo.active !== vi.active) {
        significantChange = true;
      } // update if needed


      if (significantChange) {
        setVideoInfo(vi);
      }
    }
  };

  (0, _react.useEffect)(function () {
    document.addEventListener("trc-video-info", onVideoInfoUpdate);
    return function () {
      document.removeEventListener("trc-video-info", onVideoInfoUpdate);
    };
  }, [ref, ref.current]);
  return videoInfo;
};

exports.useVideoInfo = useVideoInfo;